export enum StorageMedium {
FileSystem,
DataBase,
}
